import { SET_STATE, RESET, SET_GYM_MEMBERS, SET_GYM_NAME, SET_MY_GYMS, SET_MEMBER_OF_GYMS,SET_OTHER_GYMS, ADD_MY_GYM, DELETE_MY_GYM, ADD_GYM_MEMBER, REMOVE_GYM_MEMBER, SET_SELECTABLE_MEMBERS, SET_GYM_OCCUPATION, LEAVE_GYM } from './actionTypes'
import { receiveEndPointMessage } from '../otuVision/actions';

function initialState() {
    return {
      visible : false,
      showGymPortal: false,
      showCreateGym : false,
      showManageGym : false,
      selectableMembersSorted :[],
      selectableMembers : {},
      gymsSorted: [],
      gyms : {},
      myGyms : {},
      memberOfGyms : {},
      otherGyms : {},
      gymOccupation : {}
    }
}

export default function (state = initialState(), action) {

    switch (action.type) {

        case SET_STATE:

                const newState = action.newState
                
                for ( var key in newState ) {
                    if ( newState.hasOwnProperty( key ) && state.hasOwnProperty( key ) ) {
                        state[key] = newState[key]
                    } 
                }
           break

        case SET_SELECTABLE_MEMBERS:
                state.selectableMembers = action.selectableMembers
                var sortable=[]
                for (let [ id, member ] of Object.entries( action.selectableMembers ) ) {
                    sortable.push(member)
                }
                sortable.sort( (a,b) => ((a.profile.firstname + a.profile.lastname).toLowerCase() > ( b.profile.firstname + b.profile.lastname).toLowerCase() ? 1 : -1 ) )
                state.selectableMembersSorted=sortable

            break
        case SET_GYM_MEMBERS:
                if ( state.gyms.hasOwnProperty( action.gym.gymId ) ) {
                    state.gyms[ action.gym.gymId ].members = action.members
                } else {
                    throw 'no such gym here'
                }
            break
        case SET_GYM_NAME:
                if ( state.gyms.hasOwnProperty( action.gym.gymId ) ) {
                    state.gyms[ action.gym.gymId ].gymData.name = action.name
                } else {
                    throw 'no such gym here'
                }
                if ( state.myGyms[action.gym.gymId] ) state.myGyms = Object.assign( {},state.myGyms )
            break
        case SET_MY_GYMS:
                state.gyms = Object.assign( {}, state.gyms, action.gyms )
                state.gymsSorted = sortGyms( { gyms : state.gyms } )
                state.myGyms = action.gyms
            break
        case SET_MEMBER_OF_GYMS:
                state.gyms = Object.assign( {}, state.gyms, action.gyms )
                state.gymsSorted = sortGyms( { gyms : state.gyms } )
                state.memberOfGyms = action.gyms
            break
        case SET_OTHER_GYMS:
                state.gyms = Object.assign( {}, state.gyms, action.gyms )
                state.gymsSorted = sortGyms( { gyms : state.gyms } )
                state.otherGyms = action.gyms
            break
        case SET_GYM_OCCUPATION:
                state.gymOccupation = action.gyms
            break
        case ADD_MY_GYM:
                state.gyms[ action.gym.gymId ] = action.gym
                state.gymsSorted = sortGyms( { gyms : state.gyms } )

                state.myGyms [ action.gym.gymId ] = action.gym
                state.myGyms = Object.assign( {}, state.myGyms )
            break
        case DELETE_MY_GYM:
            state.myGyms = state.myGyms.filter(function(item) {
                return item.gymId !== action.gymId
            })
            delete state.gyms[ action.gym.gymId ]
            state.gymsSorted = sortGyms( { gyms : state.gyms } )
        break
        case ADD_GYM_MEMBER:
                state.gyms[ action.gym.gymId ].members[action.member.id]=action.member
                state.gyms[ action.gym.gymId ].memberCount = Object.keys(state.gyms[ action.gym.gymId ].members).length
                if ( state.selectableMembers[ action.member.id ] && state.selectableMembers[ action.member.id ].isOnline ) state.gyms[ action.gym.gymId ].onlineCount++

                state.gyms[ action.gym.gymId ].members = Object.assign( {}, state.gyms[ action.gym.gymId ].members)
            break
        case LEAVE_GYM:
                delete state.memberOfGyms[ action.gym.gymId ]
                state.otherGyms[ action.gym.gymId ] = state.gyms[ action.gym.gymId]
                state.memberOfGyms = Object.assign({},state.memberOfGyms)
                state.otherGyms = Object.assign({},state.otherGyms)
        case REMOVE_GYM_MEMBER:

                delete state.gyms[ action.gym.gymId ].members[action.member.id]
                state.gyms[ action.gym.gymId ].memberCount = Object.keys(state.gyms[ action.gym.gymId ].members).length
                if ( state.selectableMembers[ action.member.id ] && state.selectableMembers[ action.member.id ].isOnline ) state.gyms[ action.gym.gymId ].onlineCount--

                state.gyms[ action.gym.gymId ].members = Object.assign( {}, state.gyms[ action.gym.gymId ].members)
            break
        case RESET : 

            state = initialState()
        
            break;
            
        default:
    }

    return state;

}

function sortGyms( options={} ) {
    var sortable=[]
    for (let [ id, gym ] of Object.entries( options.gyms ) ) {
        sortable.push( gym )
    }
    sortable.sort( (a,b) => (( a.gymData.name ).toLowerCase() > ( b.gymData.name ).toLowerCase() ? 1 : -1 ) )
    return sortable
}


